import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './services/http.service';
import { ErrorHandlerService } from './services/error-handler.service';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { DatePickerModule } from '@syncfusion/ej2-angular-calendars'
import { ToastModule } from '@syncfusion/ej2-angular-notifications';
import { GtmService } from './services/gtm.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ToastModule,
    DatePickerModule
  ],
  providers: [
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    { provide: LOCALE_ID, useValue: 'es' },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    provideAnimationsAsync(),
    GtmService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
